export const fr = {
  personalInfo: {
    name: 'Ulrich Flynn NDELOKO SOBTEGOUYEM',
    title: 'Développeur logiciel',
    fneNumber: 'FNE n°: CO2-2023-1560',
    tagline: 'Création de logiciels avec précision, test avec objectif, et livraison de qualité par conception',
    summary: 'Bonjour, je m\'appelle Ulrich 👋\n\nJe suis développeur logiciel et je compte plus de trois ans d\'expérience professionnelle dans la conception, le développement et la mise en œuvre de solutions logicielles. Passionné par la technologie et l\'apprentissage continu, j\'aime résoudre des problèmes complexes et créer des applications qui apportent une réelle valeur ajoutée aux utilisateurs.\n\nMon expérience couvre l’ensemble du cycle de vie du développement logiciel, et j’utilise des technologies modernes telles que Python, JavaScript, TypeScript, React, Node.js, PostgreSQL, Docker et Azure DevOps. Tout au long de ma carrière, j’ai également acquis de solides compétences en développement Agile, en assurance qualité, en collaboration et en livraison de logiciels de haute qualité.\n\nActuellement inscrit en licence de technologie en développement logiciel, je recherche un stage en alternance en développement logiciel qui me permettra de mettre à profit mon expérience professionnelle tout en continuant à évoluer au sein du secteur technologique canadien. Je suis ouvert à des postes en alternance à Calgary ou à distance, et je suis impatient de collaborer avec des équipes qui valorisent l’innovation, l’apprentissage et l’excellence.\n\nMerci de votre visite, j’ai hâte d’avoir l’occasion d’apporter ma contribution à votre équipe.',
    social: {
      github: 'https://github.com/UlrichFlynn',
      linkedin: 'https://www.linkedin.com/in/ulrich-flynn-ndeloko-sobtegouyem-96431b208',
      twitter: ''
    },
    contact: {
      email: 'ndelokosuf@gmail.com',
      phone: '+1 (825) 779-2005',
      location: 'Calgary, Alberta, Canada'
    }
  },
  nav: {
    home: 'Accueil',
    about: 'À Propos',
    projects: 'Projets',
    contact: 'Contact', // 'Contactez-moi'
  },
  home: {
    title: 'Développeur Logiciel',
    subtitle: 'Passionné par la création de solutions efficaces et l\'assurance qualité des logiciels.',
    description: 'Je combine expertise en développement et assurance qualité pour livrer des applications robustes et conviviales.',
    whatIDo: 'Ce Que Je Fais',
    downloadMyResume: 'Télécharger mon CV',
    skills: [
      { 
        title: 'Développement Frontend', 
        description: 'Création d\'interfaces utilisateur réactives et interactives',
        icon: 'code' 
      },
      { 
        title: 'Développement Backend', 
        description: 'Construction de solutions côté serveur robustes',
        icon: 'build'
      },
      { 
        title: 'Résolution de Problèmes', 
        description: 'Approche analytique des défis',
        icon: 'lightbulb'
      }
    ]
  },
  about: {
    title: 'À Propos de Moi',
    introduction: 'Mon parcours dans la technologie a commencé par une profonde curiosité pour le fonctionnement des choses, ce qui m\'a conduit à poursuivre une carrière dans le développement logiciel. Ce qui m\'anime le plus, c\'est l\'intersection entre un code propre et l\'assurance qualité, où je peux construire des applications robustes tout en m\'assurant qu\'elles répondent aux normes les plus élevées. Je m\'adonne à la lecture, ce qui m\'aide à maintenir une perspective fraîche sur la résolution de problèmes et la créativité dans mon travail.',
    experience: {
      title: 'Expériences professionnelles',
      positions: [
        {
          title: 'Développeur Logiciel & Ingénieur QA',
          company: 'Biomedical Technical Engineering Services SARL',
          location: 'Yaoundé, Cameroun',
          period: 'Mai 2024 à mai 2025',
          responsibilities: [
            'Développer des applications web évolutives de gestion d\'événements et de ressources à l\'aide de Node.js, Express.js, JavaScript et TypeScript.',
            'Mise en place de tests automatisés de bout en bout avec Cypress et de tests de performance avec Grafana K6.',
            'Créer des modèles de base Express.js réutilisables, d\'outils d\'automatisation des tests et de modèles de prompt afin d\'accélérer le développement.',
            'A occupé le poste de Scrum Master, en animant les réunions Agile et en coordonnant la mise en œuvre interfonctionnelle.'
          ]
        },
        {
          title: 'Développeur Logiciel',
          company: 'IS DEV EXPERTS',
          location: 'Douala, Cameroun',
          period: 'Novembre 2023 à avril 2024',
          responsibilities: [
            'Développement de systèmes backend basés sur des microservices prenant en charge la communication en temps réel.',
            'A collaboré avec des équipes de développement utilisant des méthodes agiles.'
          ]
        },
        {
          title: 'Développeur Node.js (remote)',
          company: 'IdealBox',
          location: 'Buea, Cameroun',
          period: 'Juillet 2023 à décembre 2023',
          responsibilities: [
            'Analyse et planification de projet',
            'Développer des services backend avec Node.js et TypeScript.',
            'Fonctionnalités de l\'application intégrée basée sur React.'
          ]
        },
        {
          title: 'Développeur Logiciel',
          company: 'SMARTCODE Group',
          location: 'Douala, Cameroun',
          period: 'Mai 2022 à mai 2023',
          responsibilities: [
            'Contribuer à l\'analyse des projets.',
            'Développement et maintenance d\'applications backend et web.',
            'Contributuer au développement du frontend.',
            'Utilisation du système de contrôle de version Git pour gérer les différentes versions du code.',
            'Organiser des réunions avec les clients.'
          ]
        },
        {
          title: 'Stagiaire',
          company: 'SMARTCODE Group',
          location: 'Douala, Cameroun',
          period: 'Juillet 2021 à mai 2022',
          responsibilities: [
            'Apprentissage de Node.js, Express.js et MongoDB.',
            'Reprise et poursuite du développement du back-end d\'une application mobile.',
            'Maintenir le back-end d\'une application web.',
            'Utilisation du système de contrôle de version Git pour gérer les différentes versions du code.',
            'Organiser des réunions avec les clients.'
          ]
        },
        {
          title: 'Stagiaire',
          company: 'AFRITEC LTD',
          location: 'Douala, Cameroun',
          period: 'Juin 2019 à août 2019',
          responsibilities: [
            'Apprentissage des bases de la programmation.',
            'Apprentissage du langage de programmation Java.',
            'Développement d\'un système de gestion des stocks avec Java et SQL.'
          ]
        }
      ]
    },
    education: {
      title: 'Formations',
      items: [
        {
          title: 'Licence en technologie, spécialité Développement Logiciel (en cours)',
          institution: 'Southern Alberta Institute of Technology (SAIT)',
          period: 'De janvier 2026 à aujourd\'hui',
          location: 'Calgary, Alberta, Canada',
          description: 'Un cursus de licence en technologie axé sur la pratique et consacré au développement logiciel « full-stack », couvrant la programmation, le développement web, la conception de bases de données, les tests logiciels, la sécurité, les algorithmes, les structures de données et l\'architecture logicielle. Grâce à des projets concrets, j\'acquiers les compétences nécessaires pour concevoir, développer, tester et déployer des solutions logicielles centrées sur l\'utilisateur.'
        },
        {
          title: 'JavaScript Essentials Certificate',
          institution: 'OpenEDG JavaScript Institute',
          period: 'De février 2023 à avril 2023',
          location: 'En ligne',
          description: 'L\'objectif principal du cours est de vous faire passer d\'un état d\'analphabétisme total en matière de programmation à un niveau de connaissances en programmation qui vous permette de concevoir, d\'écrire, d\'exécuter et de déboguer des programmes codés en langage JavaScript, et de comprendre les concepts de base de la technologie de développement de logiciels.'
        },
        {
          title: 'Système de contrôle de version Git',
          institution: 'Udacity',
          period: 'De janvier 2023 à février 2023',
          location: 'En ligne',
          description: 'Ce cours couvre l\'essentiel de l\'utilisation du système de contrôle de version Git. Vous serez en mesure de créer un nouveau repo Git, de livrer des modifications et de consulter l\'historique des livraisons d\'un repo existant. Vous apprendrez également à organiser vos livraisons à l\'aide de balises et de branches, et vous maîtriserez l\'art de fusionner les modifications, en éliminant les conflits de fusion gênants.'
        },
        {
          title: 'NDG Linux Unhatched Certificate',
          institution: 'Cisco Networking Academy',
          period: 'Janvier 2023',
          location: 'En ligne',
          description: 'Apprendre les bases de l\'installation et de la configuration des logiciels Linux et s\'initier à la ligne de commande Linux.'
        },
        {
          title: 'Licence en technologie, spécialité Génie Logiciel',
          institution: 'Institut Universitaire de la Côte',
          period: 'D\'octobre 2020 à juillet 2021',
          location: 'Douala, Cameroun',
          description: 'Une licence en technologie avec spécialisation en génie logiciel, axée sur le développement de logiciels complets.'
        },
        {
          title: 'Brevet de Technicien Supérieur, spécialité Génie Logiciel',
          institution: 'Institut Universitaire de la Côte',
          period: 'De novembre 2018 à août 2020',
          location: 'Douala, Cameroun',
          description: 'Un diplôme de technicien supérieur avec spécialisation en génie logiciel, axé sur le développement de logiciels complets.'
        },
        {
          title: 'GCE Advanced Level',
          institution: 'Lycée Bilingue de Deïdo',
          period: 'De 2014 à 2016',
          location: 'Douala, Cameroun'
        },
        {
          title: 'GCE Ordinary Level',
          institution: 'Lycée Bilingue de Deïdo',
          period: 'De 2009 à 2014',
          location: 'Douala, Cameroun'
        }
      ]
    },
    certifications: {
      title: "Licences et Certifications",
      items: [
        {
          title: "JavaScript Essentials 1",
          period: "Février 2023 - Avril 2023",
          issuer: "OpenEDG JavaScript Institute",
          id: "English 0323 cga"
        },
        {
          title: "NDG Linux Unhatched",
          period: "Janvier 2023",
          issuer: "Cisco Networking Academy",
          id: "English 1022b"
        }
      ]
    },
    skills: {
      title: 'Compétences Techniques',
      categories: {
        frontend: 'Frontend',
        backend: 'Backend',
        testing: 'QA & Tests',
        prompting: 'Ingénierie des Prompt',
        tools: 'Outils & Méthodes',
      },
    },
  },
  skills: {
    title: 'Compétences',
    categories: {
      webDev: {
        title: 'Développement Web',
        skills: ['HTML', 'CSS', 'JavaScript', 'TypeScript', 'Python']
      },
      frameworks: {
        title: 'Frameworks & Bibliothèques',
        skills: ['React', 'Angular', 'Node.js', 'FastAPI']
      },
      databases: {
        title: 'Bases de Données',
        skills: ['MongoDB', 'PostgreSQL']
      },
      apis: {
        title: 'APIs & Communication',
        skills: ['REST API', 'GraphQL', 'KafkaJS']
      },
      devOps: {
        title: 'DevOps & Outils',
        skills: ['Docker', 'Azure DevOps', 'Git', 'Git flow']
      },
      testing: {
        title: 'Tests & Qualité',
        skills: ['Cypress', 'K6', 'Revue du code']
      },
      other: {
        title: 'Autres Technologies',
        skills: ['Ingénierie des Prompts', 'Architecture Microservices']
      },
      methodologies: {
        title: 'Méthodologies',
        skills: ['Agile Scrum']
      }
    }
  },
  interests: {
    title: 'Centres d\'intérêt',
    items: [
      {
        name: 'Lecture',
        icon: 'book'
      },
      {
        name: 'Sport',
        icon: 'sports'
      },
      {
        name: 'Ecouter de la musique',
        icon: 'music'
      }
    ]
  },
  projects: {
    title: 'Projets',
    viewProject: 'Voir le Projet',
    viewBackendRepo: 'Voir le Dépôt Backend',
    viewFrontendRepo: 'Voir le Dépôt Frontend',
    viewRepo: 'Voir le Dépôt',
    technologies: 'Technologies',
    responsibilities: 'Responsabilités Clés',
    items: [
      {
        title: 'JonEasyPro',
        period: 'Novembre 2023 - Avril 2024',
        company: 'IS DEV EXPERTS',
        location: 'Douala, Cameroun',
        description: "Il s'agit d'une application de gestion de bar qui facilite le service et le suivi des commandes.",
        responsibilities: [
          'Développement des services backend avec Node.js et Express.js',
          "Implémentation d'une architecture microservices avec Docker et Kafka",
          'Gestion de la conception et implémentation de la base de données avec MongoDB et Mongoose',
          'Application des méthodologies agiles et Git Flow pour le contrôle de version'
        ],
        technologies: [
          'Node.js',
          'Express.js',
          'MongoDB',
          'Mongoose',
          'Docker',
          'KafkaJS',
          'Git Flow',
          'Jira'
        ]
      },
      {
        title: 'Cible360',
        period: 'Novembre 2022 - Mai 2023',
        company: 'SMARTCODE Group',
        location: 'Douala, Cameroun',
        description: "Il s'agit d'une plateforme qui suit les utilisateurs dans leur processus d'immigration au Canada.",
        link: 'https://cible360.groupe-cible.ca',
        responsibilities: [
          'Développement de la logique back-end',
          "Développement du panneau de l'administrateur",
          'Organisation de réunions avec le client',
          "Aide au développement de l'interface utilisateur"
        ],
        technologies: [
          'Node.js',
          'Express.js',
          'MongoDB',
          'Mongoose',
          'EJS',
          'Git',
          'Scrum',
          'Asana',
          'Trello'
        ]
      },
      {
        title: 'Cible Placement',
        period: 'Mai 2022 - Novembre 2022',
        company: 'SMARTCODE Group',
        location: 'Douala, Cameroun',
        description: "Il s'agit d'une application web qui aide les demandeurs d'emploi à trouver des opportunités d'emploi au Cameroun et au Canada. Elle aide également les entreprises à trouver des candidats correspondant à leurs offres d'emploi.",
        link: 'https://ciblestafi.groupe-cible.ca',
        responsibilities: [
          'Développement de la logique du back-end',
          "Développement du panneau de l'administrateur",
          'Organisation de réunions avec le client',
          'Aide au développement du front-end'
        ],
        technologies: [
          'Node.js',
          'Express.js',
          'MongoDB',
          'Mongoose',
          'EJS',
          'Git',
          'Scrum',
          'Asana',
          'Trello'
        ]
      },
      {
        title: 'Prions Sans Cesse',
        period: 'Janvier 2022 - Avril 2022',
        company: 'SMARTCODE Group',
        location: 'Douala, Cameroun',
        description: "Il s'agit d'une plateforme qui relie ses utilisateurs du monde entier en tant que communauté pour prier ensemble et partager du contenu religieux.",
        link: 'https://prionssanscesse.com',
        responsibilities: [
          'Développement de la logique du back-end',
          "Développement du panneau de l'administrateur",
          'Participation à des réunions avec le client'
        ],
        technologies: [
          'Node.js',
          'Express.js',
          'MongoDB',
          'Mongoose',
          'API REST',
          'EJS',
          'Scrum',
          'Git',
          'Asana',
          'Trello'
        ]
      }
    ]
  },
  personalProjects: {
    title: 'Projets Personnels',
    items: [
      {
        title: 'Détection des plagiats : outil de vérification de la similitude structurelle basé sur l\'AST - Backend',
        period: 'Juillet 2026',
        description: 'Un projet académique d\'équipe qui a développé un vérificateur de similarité de code en Python basé sur l\'AST pour identifier du code potentiellement copié ou lié structurellement au-delà de la correspondance textuelle traditionnelle. Le système extrait les caractéristiques structurelles et combine les métriques de similarité cosine, Jaccard et Sous-séquence Commune la plus longue pour générer un score de similarité pondéré et une recommandation. La solution a été mise en œuvre comme une API REST FastAPI avec une architecture en couches et des tests automatisés pytest. \nType de projet: Projet d\'équipe académique',
        linkRepo: 'https://github.com/UlrichFlynn/Catching-the-Copy-BO',
        technologies: [
          'Python',
          'FastAPI',
          'AST',
          'Pydantic',
          'pytest',
          'REST API'
        ]
      },
      {
        title: 'Système de gestion des tâches - Back-end',
        period: 'Avril 2026',
        description: 'Une application de gestion des tâches « full-stack » dotée d\'une API RESTful sécurisée, d\'une authentification JWT et d\'une gestion des tâches personnalisée par utilisateur. Développée avec Node.js et Express.js, la partie backend utilise MongoDB et Mongoose pour la persistance des données et met en œuvre le hachage des mots de passe via bcrypt, les opérations CRUD, un middleware d\'authentification, la gestion des erreurs, ainsi qu\'une architecture structurée de type « contrôleur-service ». La partie frontend est développée avec Next.js.',
        linkBackend: 'https://github.com/UlrichFlynn/task-management-system',
        technologies: [
          'Node.js',
          'Express.js',
          'MongoDB',
          'Mongoose',
          'JWT',
          'bcrypt',
          'Next.js'
        ]
      },
      {
        title: 'CaeliCast - Application de prévisions météo',
        period: 'Mai 2025',
        description: 'Une application météo responsive développée avec Next.js et React, qui utilise l\'API WeatherAPI.com pour fournir des informations météorologiques en temps réel pour n\'importe quel lieu. Elle propose une interface moderne, des indicateurs météo visuels, des composants réutilisables et un design responsive utilisant Tailwind CSS.',
        link: 'https://weather-app-alpha-khaki-24.vercel.app/',
        linkRepo: 'https://github.com/UlrichFlynn/weather-app',
        technologies: [
          'Next.js',
          'React',
          'API WeatherAPI.com',
          'Tailwind CSS (pour la mise en forme)'
        ]
      },
      {
        title: 'MailFile',
        period: 'Septembre 2023',
        description: "Il s'agit d'un petit projet fullstack réalisé en Node.js et React. L'objectif de cette application est de transférer de gros fichiers. Son fonctionnement est le même que celui de WeTransfer et MailBigFile.",
        linkBackend: 'https://github.com/UlrichFlynn/Back-MailFile',
        linkFrontend: 'https://github.com/UlrichFlynn/Front-MailFile',
        technologies: [
          'Node.js',
          'React',
          'Express.js',
          'MongoDB',
          'Tailwind CSS'
        ]
      },
      {
        title: 'Cloud Kitchen Web',
        period: 'Janvier 2023',
        description: 'Un site web statique pour un restaurant.',
        link: 'https://ulrichflynn.github.io/CloudChickenWeb-Tuto/',
        linkRepo: 'https://github.com/UlrichFlynn/CloudChickenWeb-Tuto',
        technologies: [
          'HTML',
          'CSS',
          'JavaScript',
          'Angular'
        ]
      }
    ]
  },
  strengths: {
    title: 'Atouts',
    items: [
      {
        name: 'Organisé',
        icon: 'organize'
      },
      {
        name: 'Ponctualité',
        icon: 'time'
      },
      {
        name: 'Travail d\'équipe',
        icon: 'team'
      },
      {
        name: 'Discipliné',
        icon: 'discipline'
      }
    ]
  },
  languages: {
    title: 'Langues',
    items: [
      {
        name: 'Anglais',
        level: ' '
      },
      {
        name: 'Français',
        level: ' '
      }
    ]
  },
  contactInfo: {
    title: 'Contact',
    email: 'ulrichflynn9@gmail.com',
    location: 'Yaoundé',
    phone: '6 94 08 82 05',
    labels: {
      email: 'Email',
      location: 'Localisation',
      phone: 'Téléphone'
    },
    name: 'Nom',
    message: 'Message',
    send: 'Envoyer le Message',
  },
  contact: {
    title: 'Contactez-moi',
    subtitle: 'Restons en contact',
    form: {
      name: 'Nom',
      email: 'Email',
      message: 'Message',
      submit: 'Envoyer le message',
      success: 'Votre message a été envoyé avec succès !',
      error: 'Une erreur est survenue lors de l\'envoi de votre message. Veuillez réessayer.'
    },
    info: {
      title: 'Coordonnées',
      email: 'Envoyez-moi un email à',
      phone: 'Appelez-moi au',
      location: 'Trouvez-moi à',
      availability: 'Disponible pour des stages en alternance à Calgary ou des postes à distance. Ouvert à la collaboration et désireux de contribuer à des projets innovants.'
    }
  },
  common: {
    loading: 'Chargement...',
    error: 'Une erreur est survenue',
    success: 'Succès !',
  },
};
